import styled from 'styled-components';
import { SummaryDiscountDetailsStyled } from '../SummaryDiscountDetailsStyled';
import { rem } from 'polished';

export const SummaryDiscountDetailsDS = styled(SummaryDiscountDetailsStyled)`
    border-top: ${rem(1)} solid ${({ theme }) => theme.colors.secondary};

    .titleWrapper {
        .title {
            font-size: ${({ theme }) => theme.fontSizes.h4};
            text-transform: uppercase;
        }
    }

    .section {
        .description {
            font-size: ${({ theme }) => theme.fontSizes.h5};
        }
        .discounts {
            .discount,
            .totalPrice {
                font-size: ${({ theme }) => theme.fontSizes.h5};
            }
        }
    }
`;
